import { useMemo } from 'react';

import { useCartContext } from '@fhs-legacy/frontend/src/state/cart';
import { centsToDollarString } from '@fhs-legacy/frontend/src/utils/index';

import { usePaymentMethodStore } from '../payment';

import { useSelectedGiftCard } from './use-selected-gift-card';

export function useGiftCardCheckoutValidation() {
  const { serverOrder } = useCartContext();
  const selectedPaymentMethod = usePaymentMethodStore(state => state.selectedPaymentMethod);
  const selectedGiftCard = useSelectedGiftCard();
  const totalCents = serverOrder?.cart?.totalCents || 0;

  // Extract primitive values for stable memoization
  const currentBalance = selectedGiftCard?.currentBalance;
  const hasGiftCard = Boolean(selectedGiftCard);

  return useMemo(() => {
    const errorGiftCardBalanceNotEnough =
      selectedPaymentMethod === 'giftCard' &&
      hasGiftCard &&
      (currentBalance === undefined || currentBalance < totalCents);

    const giftCardDueAmountInCents = totalCents - (currentBalance ?? 0);

    const giftCardMissingAmount =
      errorGiftCardBalanceNotEnough && currentBalance !== undefined
        ? centsToDollarString(giftCardDueAmountInCents)
        : undefined;

    const showReloadGiftCardCTA = hasGiftCard && errorGiftCardBalanceNotEnough;

    return {
      errorGiftCardBalanceNotEnough,
      giftCardMissingAmount,
      showReloadGiftCardCTA,
      selectedGiftCard,
      giftCardDueAmountInCents,
    };
  }, [hasGiftCard, currentBalance, totalCents, selectedPaymentMethod, selectedGiftCard]);
}
